import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
import { Subscription } from "rxjs";
import { first } from "rxjs/operators";
import { MatTableDataSource, MatSort, MatPaginator } from "@angular/material";
import { SelectionModel } from "@angular/cdk/collections";

import { AlertService, PointsService } from "../../_services";

@Component({ templateUrl: "points.list.html" })
export class PointsList implements OnInit, OnDestroy {
  heading = "Coin Settings";
  subheading = "";
  icon = "fa fa-folder-o icon-gradient bg-happy-itmeo";
  link = "/points/add";
  points: [];
  dataSource: MatTableDataSource<any[]>;
  search_key = "";
  pageSizeOptions = null;
  displayedColumns = [
    "s_no",
    "package",
    "start_value",
    "end_value",
    "value_type",
    "package_value",
    "status",
    "actions"
  ];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  setPageSizeOptions(setPageSizeOptionsInput: string) {
    this.pageSizeOptions = setPageSizeOptionsInput.split(",").map(str => +str);
  }

  constructor(
    private pointsServices: PointsService,
    private alertService: AlertService
  ) {}

  ngOnInit() {
    this.loadAllPoints();
  }

  ngOnDestroy() {}

  clearFilters() {
    this.dataSource.filter = "";
    this.search_key = "";
  }

  private loadAllPoints() {
    this.pointsServices
      .getAll()
      .pipe(first())
      .subscribe((points: any) => {
        if (points.status == "ok") {
          this.dataSource = new MatTableDataSource(points.result_set);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        }
      });
  }

  deletePoints(id: number) {
    this.alertService.delete().then(data => {
      if (data) {
        this.pointsServices
          .delete(id)
          .pipe(first())
          .subscribe((data: any) => {
            if (data.status == "ok") {
              this.alertService.success(data.message, true);
              this.loadAllPoints();
            } else {
              this.alertService.error(data.message, true);
            }
          });
      }
    });
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
}
